import TTMain from "pages/dashboard/e-reporting/TableTransaksi/TTMain"
import { TTProvider } from "pages/dashboard/e-reporting/TableTransaksi/TTCtx"

const TTIndex = () => <TTProvider><TTMain /></TTProvider>

export default TTIndex;